import React, {useEffect, useState} from "react";
import './styles.scss'
import BackButton from "../../Common/BackButton";
import ShortCoinCard from "../ShortCoinCard";
import Button from "../../Common/Button";
import ChooseTokenModal from "../ChooseTokenModal";
import {useConfirm} from "../../../controllers/ModalConfirm";
import CircleArrowToBottom from "../../../assets/icons/CircleArrowToBottom";

const ModalLiquidityAdd = ({isOpen, onClose}) => {


    const [tokenModalOpen, setTokenModalOpen] = useState(false);

    const openTokenModal = () => {
        setTokenModalOpen(true);
    };

    const closeTokenModal = () => {
        setTokenModalOpen(false);
    };

    const confirmU = useConfirm();

    const onAddLiquidity = () =>{

        confirmU({
            isVisible: true,
            title: 'Транзакция отправлена',
            img: <CircleArrowToBottom/>,
            text: 'На ваш кошелек будет зачислено',
            textExtra: '100 CRYG',
            agreeText: 'Подтвердить',
            dontAgreeText: 'Отменить',
            onPress: () => onClose
        })
    }

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isOpen]);

    return (
        <>
            {isOpen && <div className="modal-overlay" onClick={onClose}/>}
            <div className={`modal ${isOpen ? 'open' : ''}`}>
                <div className="modal-content">
                    <BackButton
                        onPress={onClose}
                        title={'Добавить ликвидность'}
                    />

                    <div className="modal-content-title">
                        Внесите суммы
                    </div>

                    <ShortCoinCard
                        bcgColor={'#282844'}
                        name={'Вы покупаете'}
                        balance={0}
                        isWithhMax={false}
                        token={'1'}
                        tokenName={'CRYG'}
                        count={'~$333.73'}
                        onPress={openTokenModal}
                    />

                    <div style={{marginTop: 10}}/>

                    <ShortCoinCard
                        bcgColor={'#4b4a61'}
                        name={'Вы покупаете'}
                        balance={0}
                        isWithhMax={false}
                        token={'0'}
                        tokenName={'DELL'}
                        count={'~$333.73'}
                        onPress={openTokenModal}
                    />

                    <div style={{marginTop: 20}}/>

                    <Button
                        text={'Добавить'}
                        onClick={onAddLiquidity}
                    />
                </div>
            </div>
            <ChooseTokenModal isOpen={tokenModalOpen} onClose={closeTokenModal} isSecondModal={true}/>
        </>

    );
};

export default ModalLiquidityAdd